import Vue from 'vue'
import Router from 'vue-router'
import ggList from '../views/ggList'
import ggView from '../views/ggView'
import help from '../views/help'

import xzxm from '../views/xzxm'
import qysb from '../views/qysb'
import ddsh from '../views/ddsh'
import xmtb from '../views/xmtb'

import tbyqh from '../views/tbyqh'
import ysgg from '../views/ysgg'
import yswj from '../views/yswj'
import zgys from '../views/zgys'
import wjdj from '../views/wjdj'

import jgtzs from '../views/jgtzs'

import yqhs from '../views/yqhs'
import zbgg from '../views/zbgg'
import zbwj from '../views/zbwj'
import cqxg from '../views/cqxg'
import tbwj from '../views/tbwj'

import hxrgs from '../views/hxrgs'
import yydf from '../views/yydf'
import zhongbgg from '../views/zhongbgg'
import zbtzs from '../views/zbtzs'
import qsht from '../views/qsht'
import lyqk from '../views/lyqk'

import czsp from '../views/czsp'

import cjwt from '../views/cjwt'
Vue.use(Router)
export default new Router({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        // return 期望滚动到哪个的位置
        if (savedPosition && to.meta.keepAlive) {
            return savedPosition;
        }
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            redirect: '/ggList/1',
            component: ggList
        },
        {
            path: '/ggList/:id',
            component:ggList
        },
        {
            path: '/ggView',
            component:ggView
        },
        {
            path: '/helpCenter',
            component:help,
            children:[
                {
                    path:'1.1.1',
                    component:xzxm
                },
                {
                    path:'1.1.2',
                    component:qysb
                },
                {
                    path:'1.1.3',
                    component:ddsh
                },
                {
                    path:'1.1.4',
                    component:xmtb
                },
                {
                    path:'1.1.4',
                    component:xmtb
                },
                {
                    path:'1.2.1',
                    component:tbyqh
                },
                {
                    path:'1.2.2',
                    component:ysgg
                },
                {
                    path:'1.2.3',
                    component:yswj
                },
                {
                    path:'1.2.4',
                    component:zgys
                },
                {
                    path:'1.2.5',
                    component:wjdj
                },
                {
                    path:'1.2.6',
                    component:jgtzs
                },
                {
                    path:'1.3.1',
                    component:yqhs
                },
                {
                    path:'1.3.2',
                    component:zbgg
                },
                {
                    path:'1.3.3',
                    component:zbwj
                },
                {
                    path:'1.3.4',
                    component:cqxg
                },
                {
                    path:'1.3.5',
                    component:tbwj
                },
                {
                    path:'1.4.1',
                    component:hxrgs
                },
                {
                    path:'1.4.2',
                    component:yydf
                },
                {
                    path:'1.4.3',
                    component:zhongbgg
                },
                {
                    path:'1.4.4',
                    component:zbtzs
                },
                {
                    path:'1.4.5',
                    component:qsht
                },
                {
                    path:'1.4.6',
                    component:lyqk
                },
                {
                    path:'1.5',
                    component:czsp
                },
                {
                    path:'2',
                    component:cjwt
                }

            ]
        }
    ]
})